/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForAzureCsp extends models.ServiceAccountCredentialsBaseForAzureApplication {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForAzureCsp");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForAzureCsp.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForAzureCsp>): ServiceAccountCredentialsBaseForAzureCsp {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForAzureCsp(), model);
        ServiceAccountCredentialsBaseForAzureCsp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForAzureCsp>): ServiceAccountCredentialsBaseForAzureCsp {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForAzureCsp.newInstance(<ServiceAccountCredentialsBaseForAzureCsp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForAzureCsp) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForAzureCsp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForAzureCsp): boolean {
        if (models.ServiceAccountCredentialsBaseForAzureApplication.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForAzureCsp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Storage Account Tenant Id.
     */
    storage_account_tenant_id: string;

    /**
     * Storage Account Application Id.
     */
    storage_account_application_id: string;

    /**
     * Storage Account Application Secret.
     */
    storage_account_application_secret: string;

}
